import _typeof from "@babel/runtime/helpers/typeof";
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var isElementConstructor = function isElementConstructor(icon) {
  return _typeof(icon) === 'object' && icon !== null && 'render' in icon;
};
export function Icon(_ref) {
  var Icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    dataTestId = _ref['data-test-id'],
    decor = _ref.decor;
  var isIcon = isElementConstructor(Icon);
  var isImg = !isIcon && _typeof(Icon) === 'object' && Icon !== null && 'src' in Icon;
  if (isIcon || isImg) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.icon,
      "data-size": size,
      "data-test-id": dataTestId,
      "data-decor": decor || undefined,
      children: [isIcon && /*#__PURE__*/_jsx(Icon, {}), isImg && /*#__PURE__*/_jsx("img", {
        src: Icon.src,
        alt: Icon.alt
      })]
    });
  }
  return Icon;
}